import React, { useContext, useState } from 'react';
import './BMCBenefitOfSuppliesOldVersion.css'
import ecoproLogo from '../../../../../assets/images/teaser_ecopro_logo.png';
import { useTranslation, Trans } from 'react-i18next';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { shenlongPageDisplayInfoContext } from '../../../Shared/BenefitOfSuppliesMain';
import { BMC_SHENLONG_SERVICE_TYPES, featureSwitchName, BONUS_PAGE_COUNT } from '../../../../../constants/AppConstants';
import { getTrailContentBOSPage, IsHWIncServiceNativeApp } from '../../../../../constants/AppMethod';
import convertHtmlToReact from '@hedgedoc/html-to-react';
import HardwareInclusiveContent from '../../../Shared/HardwareInclusiveContent';
import EcoProBenefitPoints from '../../../Shared/EcoPro/BenefitPoints/BenefitPoints';
import LearnMore from '../../../Shared/LearnMore/LearnMore';

const PromotionBannerModal = ({countryCode}) => {
    const { t } = useTranslation(["translation"]);
    const teaserPageDisplayInfo = useContext(shenlongPageDisplayInfoContext);
    const {featureSwitchValues} = teaserPageDisplayInfo;
    const PromotionBanners = featureSwitchValues?.[featureSwitchName.PROMOTION_BANNERS];
    const BonusPages = featureSwitchValues?.[featureSwitchName.BONUS_PAGES];
    const [modalState, setModalState] = useState(true);
    const toggleModal  = () => {
        setModalState(!modalState);
    }
    const closeBtn = <svg xmlns="http://www.w3.org/2000/svg" onClick={() => toggleModal()} width="14" height="13" viewBox="0 0 14 13" fill="none">
        <line x1="1.41421" y1="1" x2="12" y2="11.5858" stroke="white" stroke-width="2" stroke-linecap="round"/>
        <line x1="2" y1="11.5858" x2="12.5858" y2="1" stroke="white" stroke-width="2" stroke-linecap="round"/>
        </svg>


    return (
        <div className='teaser-promotion-wrapper'>
            <Modal isOpen={modalState} toggle={() => toggleModal()} backdrop={false} size="sm" className="teaser-page-prmotion-banner-modal" >
                <ModalHeader close={closeBtn}></ModalHeader>
                <ModalBody>
                {
                    PromotionBanners ?
                        <>
                            <Trans i18nKey="PROMOTION_BANNER.LIMITED_OFFER">
                                Limited-time offer: Exclusive  <strong>6 months Free</strong> EcoPro subscription
                            </Trans>
                            {BonusPages ?<> <p>{t("PROMOTION_BANNER.BONUS_PAGES", {pageCount:BONUS_PAGE_COUNT})}</p>
                             </>: null}
 
                        </>
                        :
                        <>
 
                            {
                                BonusPages ?
                                    <>
                                         <p>{t("PROMOTION_BANNER.SAVE_MORE")}</p>
                                         <div>{t("PROMOTION_BANNER.BONUS_PAGES_FREE_TRIAL", {pageCount:BONUS_PAGE_COUNT})} </div>
                                    </>
                                    :
                                    <>
                                        <div>{t("PROMOTION_BANNER.TWO_OR_FOUR_MONTHS_PROMOTION")} </div>
                                    </>
                            }
 
 
 
                        </>
                }

                </ModalBody>
            </Modal>
        </div>
    )
}

const BMCBenefitOfSuppliesOldVersion = () => {
    const { t } = useTranslation(["translation"]);
    const isHWInc = IsHWIncServiceNativeApp();
    const teaserPageDisplayInfo = useContext(shenlongPageDisplayInfoContext);
    const {
        planResult,
        countryCode,
        planCurrency,
        planPrice,
        featureSwitchValues
    } = teaserPageDisplayInfo;

    const PromotionBanners = featureSwitchValues?.[featureSwitchName.PROMOTION_BANNERS];
    const BonusPages = featureSwitchValues?.[featureSwitchName.BONUS_PAGES];


    return (
        <div className='benefit-of-supplies' id="promotion-page">
            <div className='supply-service-img'>
                <img src={planResult?.plans?.deviceBannerImageUrl} alt="supply service"/>
            </div>
            <div>
                <img src={ecoproLogo} alt="supply service"/>
            </div>
            {
                (isHWInc)
                ? <HardwareInclusiveContent />
                : <div>
                    <div className="mt-15 fw-b f-16">{t("ECOPRO_BENEFIT_OF_SUPPLIES_PAGE.HEADER")}</div>
                    <div className='f-14 supply-service-info'>
                        <EcoProBenefitPoints />
                    </div>
                    <div className='mt-10 f-14 promotion-content'>
                        {convertHtmlToReact(t('BENEFITS_OF_SUPPLIES.PROMOTION_CONTENT'), [true])}
                    </div>
                    <div className='supply-service-tc f-14'>
                        { 
                            (!planResult?.error) && <div className='promotion-content'>
                                <Trans i18nKey="BENEFITS_OF_SUPPLIES.STARTING_FROM" planCurrency={planCurrency} planPrice={planPrice}>
                                    Starting from as low as <span>{{planPrice}}</span>. T&Cs apply.
                                </Trans>
                            </div>
                        }
                    </div>
                    <div className='try-free'>
                        {getTrailContentBOSPage(PromotionBanners, BonusPages)}
                    </div>
                    <div className='link-wrapper'>
                        <LearnMore type={BMC_SHENLONG_SERVICE_TYPES.ECOPRO}/>
                    </div>
                    <PromotionBannerModal countryCode={countryCode}/>
                </div>
            }
        </div>
    );
};

export default BMCBenefitOfSuppliesOldVersion;